import React, { useState, useEffect } from "react";
import { dateToString } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

import DropdownList from "~/pages/portfolio/PortfolioMemo/components/DropdownList";
import FileItem from "./FileItem";
import AddMemo from "./AddMemo";

//Assets
import "~/assets/sass/pages/portfolio/portfolioMemo.scss";
import darkNewImg from "~/common/components/Images";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

const MemoItem = ({ portfolioIdx, memo, isMine, isReply, onAdd, onEdit, onDelete }) => {
	const [showAddMemo, setShowAddMemo] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [files, setFiles] = useState([]);
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();

	const handleShowMemo = () => {
		setShowAddMemo(true);
	};
	const deleteModalOpen = (idx) => {
		onDelete && onDelete(idx);
	};

	const modifyModalOpen = (idx) => {
		setEditMode(true);
		// onModify && onModify(idx);
	};

	useEffect(() => {
		const files = memo?.VcMemoFile?.map((f) => {
			return {
				file: {
					name: f?.fileName,
				},
				idx: f?.idx,
			};
		});
		setFiles(files);
	}, memo.VcMemoFile);

	return (
		<>
			<div className="memo-view">
				<div className="profile-img">
					<img
						src={memo.img ? memo.img : theme === "dark" ? darkNewImg : lightProfileImg}
						alt={t("pages.portfolio.PortfolioMemo.components.MemoItem.profile")}
					/>
				</div>
				<div className="memo-info">
					<div className="memo-name">{memo.name}</div>
					{editMode ? (
						<div className="memo-edit">
							<AddMemo
								portfolioIdx={portfolioIdx}
								pMemoIdx={memo.idx}
								replyTo={memo.name}
								isEdit={true}
								memo={memo.content}
								files={files}
								onEdit={(msg) => {
									setShowAddMemo(false);
									setEditMode(false);
									onEdit && onEdit(msg);
								}}
							/>
						</div>
					) : (
						<>
							<div className="memo-text">
								{memo.content !== "undefined"
									? memo.content.split("\r\n").map((text) => {
											return (
												<span>
													{text}
													<br />
												</span>
											);
									  })
									: ""}
							</div>
							{memo.VcMemoFile?.length > 0 && (
								<ul className="file-list">
									{memo.VcMemoFile.map((file) => (
										<FileItem key={file.fileName} file={file} />
									))}
								</ul>
							)}
						</>
					)}
					<div className="memo-date">
						<span className="date">
							{dateToString(memo.createDate, "yyyy.MM.dd HH:mm")}
						</span>
						{!isReply && (
							<button className="reply-button" onClick={handleShowMemo}>
								{t("pages.portfolio.PortfolioMemo.components.MemoItem.reply")}
							</button>
						)}
					</div>
				</div>
			</div>
			{showAddMemo && (
				<div className="memo-edit">
					<AddMemo
						portfolioIdx={portfolioIdx}
						pMemoIdx={memo.idx}
						replyTo={memo.name}
						onAdd={(msg) => {
							setShowAddMemo(false);
							onAdd && onAdd(msg);
						}}
					/>
				</div>
			)}
			{isMine && <DropdownList target={memo.idx} {...{ modifyModalOpen, deleteModalOpen }} />}
		</>
	);
};

export default MemoItem;
